export enum AlwaysChoice {
    Always = 'Always'
}
